import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useTranslations from '@hooks/useTranslations';
import { IModalPostalCode } from './index';
import LocationInput from '@components/FilterBox/Stock/Components/LocationInput';
import { Redux } from '../../../redux';
import FilterDuck from '../../../redux/filters/filter.duck';

const SECTION_ID = 'location';
const LOCATION_CLASS = 'pac-item';

export const ModalPostalCodeTemplate = ({ className, onClose }: IModalPostalCode) => {
    const { t } = useTranslations();

    const geoLocation = useSelector((state: Redux) => FilterDuck.getGeoLocation(state));

    const [userInput, setUserInput] = useState(null);
    const [showRequiredError, setShowRequiredError] = useState(false);
    const [showInvalidError, setShowInvalidError] = useState(false);
    const [showNoSelectError, showSetNoSelectError] = useState(false);

    const onSubmit = () => {
        setShowRequiredError(false);
        setShowInvalidError(false);
        showSetNoSelectError(false);

        if (!userInput || userInput === '') {
            return setShowRequiredError(true);
        }

        if (userInput && !geoLocation) {
            document?.getElementById(SECTION_ID)?.getElementsByTagName('input')[0]?.focus();

            const hasResultByUserInput = document?.getElementsByClassName(LOCATION_CLASS)?.length > 0;

            return hasResultByUserInput ? showSetNoSelectError(true) : setShowInvalidError(true);
        }

        onClose();
    };

    return (
        <div className={className}>
            <div className="title">{t('modal.postalCode.title')}</div>
            <div className="description">{t('modal.postalCode.description')}</div>
            {showNoSelectError && <div className="noSelect">{t('modal.postalCode.error.select')}</div>}
            <div
                id={SECTION_ID}
                className={`input ${showRequiredError || showRequiredError || showInvalidError ? 'hasError' : ''}`}
            >
                <LocationInput setUserInput={setUserInput} showOnlyInput />
                <button onClick={onSubmit}>{t('modal.postalCode.button')}</button>
            </div>
            {showRequiredError && <span className="error">{t('modal.postalCode.error.required')}</span>}
            {showInvalidError && <span className="error">{t('modal.postalCode.error.invalid')}</span>}
        </div>
    );
};
